import { useSelector } from 'react-redux';
import { getUserCurrentCity } from '@/stores/slices/userSlice';
import { getTitle } from '@/stores/slices/titleSlice';
import useDefiningCity from '@/hooks/useDefiningCity';
import useDefiningLang from '@/hooks/useDefiningLang';
import Layout from './Layout';
import useLadyService from '@/services/LadyService';
import { getUserRegion } from '@/stores/slices/userSlice';
import useLanguageRedirect from '@/hooks/useLanguageRedirect';
import LayoutLk from './LayoutLk';
import { useLocation } from 'react-router-dom';
import { getCountrySlug } from '../../../stores/slices/userSlice';
import PrivateRoute from '../../private-route/private-route';
import RedirectPage from '../RedirectPage';
import { useMemo } from 'react';

const MainLayout = ({ initialData, children }) => {
	const { userCity, t, userTypeAgency } = useLadyService();
	const { pathname } = useLocation();
	useDefiningLang();
	useDefiningCity();
	useLanguageRedirect();

	const { currentCity, region, countrySlug, title } = useSelector(
		(state) => ({
			currentCity: getUserCurrentCity(state),
			region: getUserRegion(state),
			countrySlug: getCountrySlug(state),
			title: getTitle(state),
		}),
	);

	const pageMeta = useMemo(() => {
		const countryCode =
			currentCity?.icon?.toLowerCase?.() || 'cz';
		let postTitle = t('titlecountry', {
			Country: currentCity.title,
			CountryCode: countryCode,
		});
		let postDesc = t('descriptioncountry', { Country: currentCity.title });
		let postCity = t('incity', { City: currentCity?.title ?? '' });
		let h1Title = t('h1country');
		if (!countrySlug) {
			postTitle =
				t('title', {
					City: currentCity?.title ?? '',
					CountryCode: countryCode,
					Country: region,
				}) +
				' ' +
				postCity;
			postDesc = t('description', {
				City: currentCity?.title,
				Country: region,
			});
			postCity = `- ${currentCity?.title}`;
			h1Title = t('h1main');
		}
		const titleString = !!title.length
			? title
				.filter((item) => !!item)
				.map((item) => t(item))
				.join(', ')
			: '';

		const titleParams = titleString
			? `${userCity.title} - ${t('escortTitle')}: ${titleString}`
			: postTitle;

		return {
			titleParams,
			titleString,
			h1Title,
			postCity,
			postDesc,
		};
	}, [title, userCity, currentCity, region, countrySlug]);

	const isLk = useMemo(() => pathname.includes('/lk/'), [pathname]);
	const isRedirect = useMemo(
		() => pathname.includes('/redirect/'),
		[pathname],
	);

	if (!isLk && !isRedirect) {
		return (
			<Layout
				titleParams={pageMeta.titleParams}
				initialData={initialData}
				postDesc={
					pageMeta.titleString
						? `${pageMeta.h1Title}: ${pageMeta.titleString} - ${pageMeta.postCity}`
						: pageMeta.postDesc
				}
			>
				{children}
			</Layout>
		);
	} else if (isRedirect) {
		return <RedirectPage>{children}</RedirectPage>;
	} else {
		return (
			<PrivateRoute>
				<LayoutLk
					titleParams={
						userTypeAgency
							? pageMeta.titleParams
							: t('profuser') + ' - Lady4Love'
					}
					postDesc={pageMeta.postDesc}
				>
					{children}
				</LayoutLk>
			</PrivateRoute>
		);
	}
};

export default MainLayout;
